"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsList = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var Icon_1 = require("../../../Icon");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var useHeaderProps_1 = require("../../hooks/useHeaderProps");
var colors_1 = require("../../colors");
var notificationIcons = {
    'exclamation-circle': pro_solid_svg_icons_1.faExclamationCircle,
    check: pro_solid_svg_icons_1.faCheck,
    'question-circle': pro_solid_svg_icons_1.faQuestionCircle,
    times: pro_solid_svg_icons_1.faTimes,
    pencil: pro_solid_svg_icons_1.faPencil,
    exclamation: pro_solid_svg_icons_1.faExclamation,
    briefcase: pro_solid_svg_icons_1.faBriefcase,
    'user-plus': pro_solid_svg_icons_1.faUserPlus,
    'user-times': pro_solid_svg_icons_1.faUserTimes,
    certificate: pro_solid_svg_icons_1.faCertificate,
    circle: pro_solid_svg_icons_1.faCircle,
    'thumbs-o-up': pro_solid_svg_icons_1.faThumbsUp,
    'thumbs-o-down': pro_solid_svg_icons_1.faThumbsDown,
    'clock-o': pro_solid_svg_icons_1.faClock,
    'pencil-square-o': pro_solid_svg_icons_1.faPencilSquare,
};
var NotificationsList = function () {
    var _a;
    var _b = (0, useHeaderProps_1.useHeaderProps)(), user = _b.user, notifications = _b.notifications, totalUnreadNotifications = _b.totalUnreadNotifications, onMarkAllNotificationsAsRead = _b.onMarkAllNotificationsAsRead, onMarkNotificationAsRead = _b.onMarkNotificationAsRead, LinkComponent = _b.LinkComponent, _js = _b._js;
    if (!notifications) {
        return null;
    }
    var encodedUserName = encodeURIComponent((_a = user === null || user === void 0 ? void 0 : user.username) !== null && _a !== void 0 ? _a : '');
    var textColor = colors_1.DEFAULT_TEXT_COLOR;
    var backgroundColor = colors_1.DEFAULT_BACKGROUND_COLOR;
    var activeBackgroundColor = colors_1.DEFAULT_BACKGROUND_HIGHLIGHT_COLOR;
    var footerButtonStyles = {
        flex: 1,
        borderRadius: 0,
        borderColor: activeBackgroundColor,
        bg: backgroundColor,
        color: textColor,
        _hover: {
            bg: activeBackgroundColor,
        },
    };
    function handleMarkNotificationAsRead(e, notificationid) {
        e.stopPropagation();
        e.preventDefault();
        if (onMarkNotificationAsRead)
            onMarkNotificationAsRead(notificationid);
    }
    function handleMarkAllNotificationsAsRead() {
        if (onMarkAllNotificationsAsRead)
            onMarkAllNotificationsAsRead();
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(react_1.List, { px: 0, my: 0 }, notifications === null || notifications === void 0 ? void 0 :
            notifications.map(function (notification) { return (React.createElement(react_1.Flex, { role: "li", "aria-labelledby": "notification-label-".concat(notification.notificationid), key: notification.notificationid, href: notification.url || '', as: LinkComponent, onClick: function () { return onMarkNotificationAsRead === null || onMarkNotificationAsRead === void 0 ? void 0 : onMarkNotificationAsRead(notification.notificationid); }, align: "center", "data-feature-id": "header_notifications_list_item", bg: backgroundColor, sx: {
                    '.notification-icon': {
                        color: activeBackgroundColor,
                    },
                }, _hover: {
                    bg: activeBackgroundColor,
                    cursor: 'pointer',
                    '.notification-icon, .notification-mark-read-icon': {
                        color: textColor,
                    },
                }, 
                // Anything less than this fails to kill the underline for some reason
                style: {
                    textDecoration: 'none',
                } },
                React.createElement(Icon_1.Icon, { className: "notification-icon", "data-feature-id": "notification_icon", px: 2, type: notificationIcons[notification.icon] }),
                React.createElement(react_1.Box, { m: 2 },
                    React.createElement(react_1.Text, { m: 0, color: textColor, id: "notification-label-".concat(notification.notificationid) }, notification.message),
                    React.createElement(react_1.Text, { m: 0, color: textColor, opacity: "0.5" }, notification.timeSince)),
                React.createElement(Icon_1.Icon, { role: "button", className: "notification-mark-read-icon", "data-feature-id": "notification_mark_read_icon", "aria-label": _js('Mark as Read'), onClick: function (e) {
                        return handleMarkNotificationAsRead(e, notification.notificationid);
                    }, ml: "auto", mr: 2, type: pro_solid_svg_icons_1.faClose, color: activeBackgroundColor, _hover: { color: textColor } }))); }),
            notifications.length !== totalUnreadNotifications && (React.createElement(react_1.Flex, { justify: "center", bg: backgroundColor },
                React.createElement(LinkComponent, { href: "/User/Notifications/".concat(user === null || user === void 0 ? void 0 : user.userid, "/").concat(encodedUserName), p: 2, color: textColor, opacity: "0.5" }, _js('Show More...'))))),
        React.createElement(react_1.Flex, null,
            React.createElement(react_1.Button, __assign({ as: LinkComponent, "data-feature-id": "header_notifications_view_all_button" }, footerButtonStyles, { href: "/User/Notifications/".concat(user === null || user === void 0 ? void 0 : user.userid, "/").concat(encodedUserName), 
                // Anything less than this fails to kill the underline for some reason
                style: {
                    textDecoration: 'none',
                } }), _js('View All')),
            React.createElement(react_1.Button, __assign({}, footerButtonStyles, { onClick: function () { return handleMarkAllNotificationsAsRead(); }, "data-feature-id": "header_notifications_clear_button" }), _js('Clear')))));
};
exports.NotificationsList = NotificationsList;
